import { Outlet, Link } from 'react-router-dom';
import { useUrlRuleset } from '../../hooks/useUrlRuleset';
import { Header } from './Header';
import { RulesetContext } from './useRulesetContext';

/**
 * Layout wrapper for all ruleset-scoped routes.
 *
 * - Validates the :ruleset URL param
 * - Syncs ruleset to store
 * - Provides RulesetContext to children
 * - Shows appropriate footer text
 */
export function RulesetLayout() {
  const rulesetData = useUrlRuleset();
  const { config } = rulesetData;

  return (
    <RulesetContext.Provider value={rulesetData}>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1 container mx-auto px-4 py-8 max-w-7xl">
          <Outlet context={rulesetData} />
        </main>
        <footer className="border-t border-background-elevated py-6 text-center text-text-muted text-sm">
          <p>
            AIR RPG Character Creator &bull; {config.name}
          </p>
          <p className="mt-1">
            {config.id === 'ignus' ? (
              <>The Dreams of Ignus &bull; A homebrew setting by Chris Dumoulin</>
            ) : (
              <>Dungeons & Dragons is a trademark of Wizards of the Coast</>
            )}
          </p>
          <p className="mt-2">
            <Link
              to="/"
              className="text-accent-gold hover:underline"
            >
              Switch Ruleset
            </Link>
          </p>
        </footer>
      </div>
    </RulesetContext.Provider>
  );
}
